import { aiApi } from './ai'

export const pageSelectionApi = aiApi.injectEndpoints({
  endpoints: (builder) => ({
    // Complete page selection after OAuth
    completePageSelection: builder.mutation({
      query: ({ sessionId, selectedPages }) => ({
        url: '/social/complete-page-selection',
        method: 'POST',
        body: { sessionId, selectedPages }
      }),
      invalidatesTags: ['SocialAccounts']
    }),

    // Get available pages from temp session
    getAvailablePages: builder.query({
      query: (sessionId) => ({
        url: `/social/available-pages/${sessionId}`,
        method: 'GET'
      })
    })
  }),
});

export const {
  useCompletePageSelectionMutation,
  useGetAvailablePagesQuery
} = pageSelectionApi;